import './App.css';
import Header from './components/header/Header';
import BrandDealsInterface from './components/brandDealsInterface/BrandDealsInterface';
import BusinessbayWall from './components/businessbayWall/BusinessbayWall';
import CreatorShowcase from './components/creatorShowcase/CreatorShowcase';
import Monetise from './components/monetise/Monetise';
import Premier from './components/premier/Premier';
import Premier2 from './components/premier2/Premier2';
import Footer from './components/Footer';
import Discover from './components/discover/Discover';
import Comp1 from './components/Comp1';
import Comp3 from './components/Comp3';
import Comp7 from './components/Comp7';
import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import EnquirePopup from './Popup/EnquirePopup'


function App() {

  const [showPopup, setShowPopup] = useState(false);

  const handlePopup = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };
  
  return (
    <div className="App">
      <Header  handlePopup={handlePopup} />
      <Comp1 />
      <Monetise />
      <BrandDealsInterface />
      <BusinessbayWall />
      <Comp3 />
      <Discover />
      <Premier handlePopup={handlePopup} />
      <Premier2 handlePopup={handlePopup} />
      <CreatorShowcase />
      {/* <Comp7 /> */}
      <Footer />
      {showPopup && (
       <EnquirePopup   open={showPopup} onClose={closePopup} />
      )}
    </div>
  );
}

export default App;
